const getters = {
  myMemberId: (state) => state.information.myMemberId,
  flightInfo: (state) => state.information.flightInfo,
  loadingShow: (state) => state.information.loadingShow,
  passengerName: (state) => state.information.passengerName,
  passengerId: (state) => state.information.passengerId,
  passengerPhoneNo: (state) => state.information.passengerPhoneNo,
  passengerFlightDate: (state) => state.information.passengerFlightDate,
  passengerFlightNo: (state) => state.information.passengerFlightNo,
  agree: (state) => state.information.agree,
  passongerList: (state) => state.passongerList,
  productOrderInfo: (state) => state.productOrderInfo,
  scanType: (state) => state.scanType,
  payParameter: (state) => state.payParameter,
};

export default getters;
